import { GetHestiaPredictionsResponse } from '@api/getHestiaPredictions'

const getIsHighHomeownerLoanLikelihood = (
    hestia: GetHestiaPredictionsResponse | undefined
) =>
    !hestia?.predictions?.some(
        p => p.lender === 'MAIN_PANEL' && p.probability < 0.05
    )

export default getIsHighHomeownerLoanLikelihood
